import { PlaygroundShell } from './components/playground/PlaygroundShell';

export default function App() {
  return <PlaygroundShell />;
}
